module.exports = __webpack_public_path__ + "static/img/图片1.7a74cb5d.png";